import { WorkflowDefinitionsVersionSteps, WorkflowDefinitionsVersionVariables } from './workflow-definition';

export class WorkflowDefinitionsForm {
  workflowDefinitionId?: string;
  name: string;
  description?: string;
  bacSourceId?: number;
  startStepGuid: string;
  variables?: WorkflowDefinitionsVersionVariables[];
  steps?: WorkflowDefinitionsVersionSteps[];
}
